module.exports = "<button  class=\"btn btn-primary addbtn\" (click)=\"addfn.emit()\">Add</button>"